import { ReactNode, useMemo } from "react";

import styles from "@components/layout/Layout.module.css";

type Props = {
  children: ReactNode;
  columns: 2 | 3;
  focusSide?: "left" | "right";
};

const ColumnGrid = ({ children, columns, focusSide }: Props) => {
  const className = useMemo(() => {
    switch (columns) {
      case 2:
        return focusSide === "left"
          ? styles.twoColumnGridLeftFocus
          : focusSide === "right"
            ? styles.twoColumnGridRightFocus
            : styles.twoColumnGrid;
      case 3:
        return focusSide === "left"
          ? styles.threeColumnGridLeftFocus
          : focusSide === "right"
            ? styles.threeColumnGridRightFocus
            : styles.threeColumnGrid;
    }
  }, [columns, focusSide]);

  return <div className={className}>{children}</div>;
};

export default ColumnGrid;
